// extracted by mini-css-extract-plugin
module.exports = {"table":"MaxMinReading_table__3cQIG"};